var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCopySidebar = function SvgCopySidebar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "filter_none",
    clipPath: "url(#clip0_3403_2669)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.50016 4.16671H0.833496V17.5C0.833496 18.4167 1.5835 19.1667 2.50016 19.1667H15.8335V17.5H2.50016V4.16671ZM17.5002 0.833374H5.8335C4.91683 0.833374 4.16683 1.58337 4.16683 2.50004V14.1667C4.16683 15.0834 4.91683 15.8334 5.8335 15.8334H17.5002C18.4168 15.8334 19.1668 15.0834 19.1668 14.1667V2.50004C19.1668 1.58337 18.4168 0.833374 17.5002 0.833374ZM17.5002 14.1667H5.8335V2.50004H17.5002V14.1667Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3403_2669"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCopySidebar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/copy_sidebar.dceb2841.svg";
export { ForwardRef as ReactComponent };